module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/clipboard-0e74d66a03d68bac2a001c7e2bf19c0f.svg";